export const departmentListingActionTypes= {
    GET_DEPARTMENTLISTING_ARGS:"GET_DEPARTMENTLISTING_ARGS",
    GET_DEPARTMENTLISTING_START:"GET_DEPARTMENTLISTING_START",
    GET_DEPARTMENTLISTING_SUCCESS:"GET_DEPARTMENTLISTING_SUCCESS",
    GET_DEPARTMENTLISTING_ERROR:"GET_DEPARTMENTLISTING_ERROR",
}